import { useRef } from 'react';
import { Grid, useMediaQuery, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { ImageLoader } from '~/content/components/ImageLoader';
import form_2 from '~/content/images/references/maintain-rehaform/form_2.webp';

const Implementation_WebApp = (): JSX.Element => {
	const seo_pic = useRef(null);

	let { t } = useTranslation(['project_maintain-form']);
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
		defaultMatches: true,
	});
	// console.log({ isMd });
	//?  md: 900
	//?  lg: 1200
	//?  xl: 1536
	return (
		<Grid container spacing={4}>
			<Grid item container spacing={4} justifyContent='space-between'>
				<Grid item container xs={12} md={5} alignItems={'center'}>
					<Box>
						<Typography variant='h5' component='h3' gutterBottom sx={{ fontWeight: 700 }}>
							{t('implementation_headline_webapp')}
						</Typography>

						<Typography variant='body1' component='p' color='text.secondary'>
							{t('implementation_text_webapp')}
						</Typography>
					</Box>
				</Grid>
				<Grid
					item
					container
					xs={12}
					md={6}
					alignItems={isMd ? 'center' : 'flex-start'}
					justifyContent={isMd ? 'center' : 'flex-start'}
				>
					<Box>
						<Typography
							component='p'
							variant='caption'
							color='text.secondary'
							fontWeight='bold'
							mb={1}
						>
							{t('implementation_caption_webapp')}
						</Typography>
						<ImageLoader
							delay={true}
							intersectViewportCheck={true}
							childRef={seo_pic}
							enlargeOnClick={true}
						>
							<Box
								ref={seo_pic}
								// data-aos={isMd ? 'fade-up' : 'fade-up'}
								// component={LazyLoadImage}
								// effect="blur"
								component={'img'}
								src={form_2}
								alt='Digitales Formular für Geschäftsprozess bei Rehazentrum'
								mt={0}
								sx={{
									width: '100%',
									// minWidth: 370,
									// maxWidth: 480,

									objectFit: 'contain',
									filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
								}}
							/>
						</ImageLoader>
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Implementation_WebApp;
